import { cva } from "class-variance-authority"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-[13px] font-medium ring-offset-background transition-colors duration-[var(--duration-micro)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--focus-ring)] focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        // border-[color:var(--accent-boundary)] with the 1px GEOMETRY RESERVED in
        // every state: the token resolves to `transparent` whenever the raw brand
        // fill already clears §7's 3:1 against every surface it sits on, so Folio
        // keeps its borderless primary and nothing shifts when a tenant swap turns
        // the edge on. See deriveAccentBoundary in lib/theme.ts.
        default:
          "border border-[color:var(--accent-boundary)] bg-[var(--accent-color)] text-[var(--accent-fg)] hover:bg-[var(--accent-hover)] active:bg-[var(--accent-pressed)] shadow-[0_1px_2px_rgba(29,26,21,.06)]",
        destructive:
          "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline:
          "border border-[color:var(--interactive-border)] bg-background text-[color:var(--ink)] hover:bg-[color:var(--surface-2)] hover:text-[color:var(--ink)]",
        secondary:
          "bg-background border border-[color:var(--interactive-border)] text-[color:var(--ink)] hover:bg-[color:var(--surface-2)]",
        ghost: "hover:bg-[color:var(--surface-2)] hover:text-[color:var(--ink)]",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-8 px-3",
        sm: "h-8 px-3",
        lg: "h-10 px-4",
        icon: "h-8 w-8",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

export { buttonVariants }
